import React, { createContext, useState, useEffect } from 'react';
import Chart from 'chart.js/auto';

import { prokeyApi } from 'api/prokey';
import './cpuMonitor.css';

function CpuMonitor() {
  const [cpu, setCpu] = useState([]);

  const canvasRef = React.useRef(null);
  const chartRef = React.useRef(null);

  const renderChart = () => { 
    if (!canvasRef.current) return;

    chartRef.current = new Chart(canvasRef.current, {
      type: 'line',
      data: {
        labels: [...Array(100).keys()],
        datasets: [{
          label: 'CPU %',
          data: cpu,
          fill: true,
          borderColor: 'rgb(75, 192, 192)',
          backgroundColor: 'rgba(100, 192, 192,0.5)',
          tension: 0.1
        }]
      },
      options:{
        animation: {
          duration: 0
        },
        maintainAspectRatio: false,
        scales : {
            y : {
                min: 0,
                max: 100,
            }
        }
      }
    })
  }

  const destroyChart = () => {
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }
  };

  useEffect(() => {
    renderChart();

    return () => destroyChart();
  }, [cpu]);

  useEffect(()=>{
    const interval = setInterval(() => {
      prokeyApi
        .getResourceCpu()
        .then((response) => {
          setCpu(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className='cpuContainer'>    
      <canvas ref={canvasRef} style={{ minHeight: '200px' }} />
    </div>
  );
}

export { CpuMonitor };